<section class="galleries-shell">
  <header class="page-header">
    <div>
      <p class="eyebrow">Media</p>
      <h1>Galleries</h1>
      @if (selectedSiteId) {
        <p class="context-site">Viewing <strong>{{ selectedSiteName }}</strong></p>
      }
      <p class="intro">Assemble ordered galleries from reusable images, then reference those galleries from landingPage blocks.</p>
    </div>
  </header>

  @if (error) {
    <p class="error">{{ error }}</p>
  }

  @if (sites.length) {
    <section class="workspace-grid">
      <section class="panel list-panel">
        <header class="panel-header">
          <div>
            <p class="eyebrow">Registry</p>
            <h2>Site galleries</h2>
          </div>
          <button type="button" class="ghost small" (click)="startNewGallery()">New gallery</button>
        </header>

        @if (loading) {
          <p class="empty-state">Loading galleries...</p>
        } @else if (galleries.length) {
          <div class="gallery-list">
            @for (gallery of galleries; track gallery.id) {
              <button
                type="button"
                class="gallery-row"
                [class.is-selected]="gallery.id === selectedGalleryId"
                (click)="selectGallery(gallery.id)">
                <strong>{{ gallery.name }}</strong>
                <span>{{ gallery.imageCount }} image{{ gallery.imageCount === 1 ? '' : 's' }}</span>
              </button>
            }
          </div>
        } @else {
          <p class="empty-state">No galleries yet for this site.</p>
        }
      </section>

      <section class="panel editor-panel">
        <header class="panel-header">
          <div>
            <p class="eyebrow">Editor</p>
            <h2>{{ selectedGalleryId ? draftName || 'Untitled gallery' : 'New gallery' }}</h2>
          </div>
        </header>

        <div class="panel-body editor-grid">
          <label>
            <span>Name</span>
            <input [(ngModel)]="draftName" placeholder="Homepage gallery" />
          </label>

          <div class="add-image-row">
            <label>
              <span>Add image</span>
              <select [(ngModel)]="imageToAdd">
                <option value="">Select image</option>
                @for (image of unselectedImages; track image.id) {
                  <option [ngValue]="image.id">{{ image.originalFileName }}</option>
                }
              </select>
            </label>
            <button type="button" class="ghost" [disabled]="!imageToAdd" (click)="addImage()">Add</button>
          </div>

          <div class="selected-images">
            @if (draftImages.length) {
              @for (image of draftImages; track image.id; let imageIndex = $index) {
                <div class="selected-image-row">
                  <img class="thumb" [src]="image.contentUrl" [alt]="image.defaultAlt || image.originalFileName" />
                  <div class="selected-image-meta">
                    <strong>{{ image.originalFileName }}</strong>
                    <span>{{ image.defaultAlt || 'No default alt' }}</span>
                  </div>
                  <div class="selected-image-actions">
                    <button type="button" class="ghost small" [disabled]="imageIndex === 0" (click)="moveImage(image.id, -1)">Up</button>
                    <button type="button" class="ghost small" [disabled]="imageIndex === draftImages.length - 1" (click)="moveImage(image.id, 1)">Down</button>
                    <button type="button" class="danger small" (click)="removeImage(image.id)">Remove</button>
                  </div>
                </div>
              }
            } @else {
              <p class="empty-state">This gallery is currently empty.</p>
            }
          </div>
        </div>

        <div class="panel-actions">
          <button type="button" class="accent" [disabled]="saving || !draftName.trim()" (click)="saveGallery()">
            {{ saving ? 'Saving...' : selectedGalleryId ? 'Save gallery' : 'Create gallery' }}
          </button>
          @if (selectedGalleryId) {
            <button type="button" class="danger" [disabled]="deleting" (click)="deleteGallery()">
              {{ deleting ? 'Deleting...' : 'Delete gallery' }}
            </button>
          }
        </div>
      </section>
    </section>
  } @else {
    <section class="panel">
      <p class="empty-state">Create a site first before managing galleries.</p>
    </section>
  }
</section>
